import type { Address, } from "./Address";
import type { URL, } from "./URL";
import type { TokenEdge, } from "./TokenEdge";


export declare type TokenDefinition = {
	chainId: number;
	address: Address;
	/** mainnet address for token vs ETH EXCEPT for ETH which is for USD. */
	priceFeedAddress?: Address;
	name: string;
	symbol: string;
	label: string;
	decimals: number;
	logoURI: string;
	extensions?: TokenEdge;
	fees?: number | number[];

	/** when swapable is true, this token is a swapable SOURCE for the escrow application */
	swapable?: true;

	/** when swapto is true, this token is a swapable TARGET for the escrow application */
	swapto?: boolean;

	/** when stakable is true, this token is a stakable SOURCE for the escrow application */
	stakable?: true;

	/** when parity is true this token enjoys a 1:1 swap rate with ETH */
	parity: boolean;

	/** when flagged true, this token is considered inactive to the escrow application */
	inactive?: boolean;

	/** when flagged true, this token will be completely ignored - differs to inactive which normally greys the token out */
	disabled?: boolean;

};

export declare type TokenDefinitionWithSingleFee = TokenDefinition & {
	fee: number;
}

export const isTokenDefinition = ( value: unknown ): value is TokenDefinition => {
	if(typeof value === "object" && !Array.isArray(value) && value !== null) {
		return ["chainId", "address", "name", "symbol", "label", "decimals"].every(k => k in value);
	}
	return false;
}


export const isTokenDefinitionWithSingleFee = ( value: unknown ): value is TokenDefinitionWithSingleFee => {
	if( typeof value === "object" && !Array.isArray(value) && value !== null ) {
		if( "fee" in value ) {
			return typeof value.fee === "number";
		}
	}
	return false;
}
